import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styles from "./AdminEmailComposer.module.scss";
import Dashboard from "../dashboard/Dashboard";
import showToast from "../../utils/show.toast";

const AdminEmailComposer = () => {
  const [emails, setEmails] = useState([]);
  const [emailInput, setEmailInput] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleAddEmail = () => {
    const trimmed = emailInput.trim();

    if (emails.includes(trimmed))
      return showToast("Email already added", false);

    if (trimmed && !emails.includes(trimmed)) {
      setEmails([...emails, trimmed]);
      setEmailInput("");
    }
  };

  const handleRemoveEmail = (email) => {
    setEmails(emails.filter((e) => e !== email));
  };

  const handleSend = () => {
    if (emails.length === 0 || !subject || !message) return;

    console.log("Sending email to:", { emails, subject, message });

    setSending(true);
    showToast("Email sent successfully!", true);
    setSending(false);
    setSubject("");
    setMessage("");
    setEmails([]);
  };

  return (
    <Dashboard pageTitle="Email Composer">
      <div className={styles.emailBox}>
        <h3>Send Email</h3>

        <div className={styles.field}>
          <label>Recipients</label>
          <div className={styles.emailInputGroup}>
            <input
              type="email"
              placeholder="Enter email and press Add"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleAddEmail()}
            />
            <button type="button" onClick={handleAddEmail}>
              Add
            </button>
          </div>
          <div className={styles.emailList}>
            {emails.map((email) => (
              <span key={email} className={styles.emailTag}>
                {email}
                <button onClick={() => handleRemoveEmail(email)}>×</button>
              </span>
            ))}
          </div>
        </div>

        <div className={styles.field}>
          <label>Subject</label>
          <input
            type="text"
            placeholder="Enter email subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>

        <div className={styles.field}>
          <label>Message</label>
          <ReactQuill
            theme="snow"
            value={message}
            onChange={setMessage}
            className={styles.quill}
          />
        </div>

        <button
          className={styles.sendBtn}
          onClick={handleSend}
          disabled={sending || !subject || !message || emails.length === 0}
        >
          {sending ? "Sending..." : "Send Email"}
        </button>
      </div>
    </Dashboard>
  );
};

export default AdminEmailComposer;
